// Print helper: clones the preview into a body-level .print-container and prints.
export function printPreview(element, sizeClass = 'print-size-letter') {
  if (!element) return;
  const existing = document.querySelector('.print-container');
  if (existing) existing.remove();

  const container = document.createElement('div');
  container.className = 'print-container';
  const clone = element.cloneNode(true);
  // remove any transform scaling from the clone wrapper
  clone.style.transform = 'none';
  const inner = clone.querySelector('.onepager-preview') || clone;
  inner.classList.add(sizeClass);
  inner.style.transform = 'none';
  inner.style.boxShadow = 'none';
  container.appendChild(clone);
  document.body.appendChild(container);

  const cleanup = () => {
    container.remove();
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);
  window.print();
  setTimeout(cleanup, 1000);
}

// Print multiple documents as one packet. `nodes` is a list of DOM elements
// (each containing a .onepager-preview) that get stacked with page breaks.
export function printPacket(container) {
  if (!container) return;
  const existing = document.querySelector('.print-container');
  if (existing) existing.remove();
  const wrap = document.createElement('div');
  wrap.className = 'print-container print-packet';
  const clone = container.cloneNode(true);
  clone.style.transform = 'none';
  clone.querySelectorAll('.onepager-preview').forEach((el) => {
    el.style.transform = 'none';
    el.style.boxShadow = 'none';
  });
  wrap.appendChild(clone);
  document.body.appendChild(wrap);
  const cleanup = () => { wrap.remove(); window.removeEventListener('afterprint', cleanup); };
  window.addEventListener('afterprint', cleanup);
  window.print();
  setTimeout(cleanup, 1500);
}
